import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import firebase from './../../firebase';
import { Button, Form } from 'react-bootstrap';

const ForgetPasswordForm = () => {
  // State
  const [email, setEmail] = useState('');

  // Handler
  const handleSubmit = e => {
    e.preventDefault();
    if (email) {
      
      firebase.auth().sendPasswordResetEmail(email, {url: window.location.origin+'/?email='+email,}).then(()=>{
        toast.success(`Un e-mail est envoyé à ${email} avec un lien de réinitialisation du mot de passe`, {
          theme: 'colored'
        });
      }).catch((err)=>{
        console.error(err);
        toast.success(`Une erreur s'est produite`, {
          theme: 'light'
        });
      });

      
    }
  };

  return (
    <Form className="mt-4" onSubmit={handleSubmit}>
      <Form.Group className="mb-3">
        <Form.Control
          placeholder={'Adresse email'}
          value={email}
          name="email"
          onChange={({ target }) => setEmail(target.value)}
          type="email"
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Button className="w-100" type="submit" disabled={!email}>
        Envoyer le lien de réinitialisation
        </Button>
      </Form.Group>
    <Link className="fs--1 text-600" to="/login">
      Retour connexion
        <span className="d-inline-block ms-1"> &rarr;</span>
       </Link>
      {/* <Link className="fs--1 text-600" to="#!">
      Je ne parviens pas à récupérer mon compte en utilisant cette page
        <span className="d-inline-block ms-1"> &rarr;</span>
      // </Link> */}
    </Form>
  );
};

ForgetPasswordForm.propTypes = {
  layout: PropTypes.string
};

ForgetPasswordForm.defaultProps = { layout: 'simple' };

export default ForgetPasswordForm;
